import '../../Lightbox/Styles/_lightbox.scss'

const Lightbox = new function () {
    const that = this;
    const tabletWidth = 768;
    const desktopWidth = 1024;

    that.init = function () {
        that.setLightboxContentContainerToBody();
        const aTags = document.querySelectorAll('a[target="_lightbox"], img[target="_lightbox"]');

        if (aTags == null) {
            return;
        }

        aTags.forEach(function (item) {
            let lightboxId = item.getAttribute('data-lightbox-id');

            if (!lightboxId) {
                return;
            }

            let lightBoxDiv = document.querySelector('.lightbox-overlay-container[data-id="' + lightboxId + '"]');

            if (!lightBoxDiv) {
                return;
            }

            const openLightbox = (e) => {
                const currentTag = e.target;

                e.target.blur();
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                lightBoxDiv.classList.add('show');

                const showEvent = new Event('show');
                lightBoxDiv.dispatchEvent(showEvent);

                var videoPlayer = lightBoxDiv.querySelector('.video-container .videoPlayer');

                if (videoPlayer != null) {
                    adjustPlayerHeight(videoPlayer);
                    // The media element plugin calculates the wrong heights for the lightbox video player
                    // while the lightbox overlay is closed. Therefore we need to resize after opening the overlay
                    // that every height is correct calculated
                    window.dispatchEvent(new Event('resize'));
                }

                const lightboxCloseButton = lightBoxDiv.querySelector(".lightbox-close-button");
                const lightboxOverlay = lightBoxDiv.querySelector(".lightbox-overlay");
                const lightboxContent = lightBoxDiv.querySelector(".lightbox-content");

                if (!lightboxContent || !lightboxOverlay) {
                    return;
                }

                let isInOverlayMousedown = false;

                var preventScrollFunc = function (e) {
                    if ((e.keycode || e.which) == 32) {
                        e.preventDefault();
                    }
                };

                document.querySelector("body").style.overflow = 'hidden';


                lightboxCloseButton.setAttribute("tabindex", "0");

                if (window.innerWidth >= desktopWidth) {
                    lightboxCloseButton.focus();
                }

                // if events are already added, return here
                if (lightboxOverlay.dataset.eventsInitialized) {
                    return;
                }
                lightboxOverlay.dataset.eventsInitialized = "true";

                /* Prevent scrolling in document if modal is closing with space. */
                document.addEventListener('keydown', preventScrollFunc, false);

                /* Prevent closing the layout if clicking on the content */
                lightboxContent.addEventListener("click",
                    function (e) {
                        e.stopPropagation();
                    });

                /* Prevent closing the layout if clicking on the content */
                lightboxOverlay.addEventListener("click",
                    function (e) {
                        e.stopPropagation();
                    });
                
                lightboxOverlay.addEventListener('mousedown', () => {
                    isInOverlayMousedown = true;
                });

                lightboxOverlay.addEventListener('mouseup', () => {
                    isInOverlayMousedown = false;
                });

                lightBoxDiv.addEventListener("mouseup", function (e) {
                    if (isInOverlayMousedown ||
                        lightboxOverlay.contains(e.target)) {
                        isInOverlayMousedown = false;
                        return;
                    }

                    that.closeLightbox(e, this, lightBoxDiv, currentTag, preventScrollFunc);
                });

                lightboxCloseButton.addEventListener("click", function (e) {
                    that.closeLightbox(e, this, lightBoxDiv, currentTag, preventScrollFunc);
                });

                lightboxCloseButton.addEventListener("touch", function (e) {
                    that.closeLightbox(e, this, lightBoxDiv, currentTag, preventScrollFunc);
                });

                lightboxCloseButton.addEventListener("keydown", function (e) {
                    /* Enter, ESC, Space */
                    if (e.keyCode == 13 || e.keyCode == 27 || e.keyCode == 32) {
                        that.closeLightbox(e, this, lightBoxDiv, currentTag, preventScrollFunc);
                    }
                });

                document.addEventListener('keydown', function (e) {
                    if (lightboxCloseButton) {
                        if (e.keyCode === 27) {
                            that.closeLightbox(e, lightboxCloseButton, lightBoxDiv, currentTag, preventScrollFunc);
                        }
                    }
                })

                lightboxOverlay.dataset.eventsInitialized = "true";
            };

            const openLightboxWithKeyboard = (e) => {
                switch (e.key) {
                    case 'Enter':
                    case 'Space':
                        openLightbox(e);
                        break;
                }
            };

            item.addEventListener("click", openLightbox, false);
            item.addEventListener("keydown", openLightboxWithKeyboard, false);
        });
    };

    that.closeLightbox = function (e, closeButton, lightbox, opener, tracker) {
        const playButton = lightbox.querySelector(".mejs__playpause-button button");

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        if (lightbox.classList.contains('show')) {
            lightbox.classList.remove('show');

            if (playButton && playButton.getAttribute("title") != "Abspielen") {
                playButton.click();
            }

            const hideEvent = new Event('hide');
            lightbox.dispatchEvent(hideEvent);
        }

        closeButton.setAttribute("tabindex", -1);

        if (window.innerWidth >= tabletWidth) {
            opener.focus();
        }

        document.removeEventListener('keydown', tracker);

        document.querySelector("body").style.overflow = 'visible';
    };

    /**
     * Adjusts the video player size if the controls are displayed in two rows.
     * Needs to call after the lightbox is shown because invisible lightbox elements cant adjust video players (no height)
     * Video player height is always the height of the player because the controls are usually inside the video (overlayed)
     * @param {any} element
     * <remarks>
     * This code must be the same as in the frontend project videoplayer.js !!!
     * Workaround because we have not access between both projects
     * </remarks>
     */
    function adjustPlayerHeight(element) {
        var controls = element.querySelector(".mejs__controls");
        var videoContainer = element.querySelector('.videoPlayer__video');
        var style = null;

        if (window.getComputedStyle) {
            style = getComputedStyle(controls, null);
        } else {
            style = el.currentStyle;
        }

        var bottomVal = parseFloat(style.bottom);
        var heightVal = parseFloat(style.height);

        if (bottomVal > 0 && !isNaN(heightVal)) {
            /* Set height on video container - previously we set the value on the element but then it conflicted with the parent margin (was ignored) */
            videoContainer.style.marginBottom = (heightVal - bottomVal) + "px";
        } else {
            videoContainer.style.removeProperty("margin-bottom");
        }
    };

    that.setLightboxContentContainerToBody = function () {
        var lightboxContentContainer = document.querySelectorAll(".lightbox-overlay-container");

        if (!lightboxContentContainer) {
            return;
        }

        var body = document.querySelector('body');
        var lightboxIds = [];

        lightboxContentContainer.forEach(function (container) {
            let dataId = container.getAttribute("data-id");

            if (lightboxIds.includes(dataId)) {
                // It can be possible that we have more then one lightbox container
                // with the same id. Based on cacheable renderings vs not cacheable renderings.
                // Therefore we need to remove the doubled lightbox content container
                container.remove();
                return;
            }

            lightboxIds.push(dataId);
            body.append(container);
        });
    };
};

window.am = window.am || {};
window.am.lightbox = Lightbox;

window.addEventListener('load', window.am.lightbox.init);

export default Lightbox;